/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Done_ButtonInputs */



/**
* | output |
* | --- |
* | "Done" |
*
* @param {Team_Share_Done_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_done_button = /** @type {((inputs?: Team_Share_Done_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Done_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Done")
	if (locale === "de") return /** @type {LocalizedString} */ ("Done")
	if (locale === "it") return /** @type {LocalizedString} */ ("Done")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Done")
	if (locale === "es") return /** @type {LocalizedString} */ ("Done")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Done")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Done")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Done")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Done")
	return /** @type {LocalizedString} */ ("Done")
});